// TODO: add tests

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const round = (num: number) => {
  // Keep only 3 decimals
  const helpNum = Number(num.toFixed(3));
  const res = roundTo(helpNum, 3);

  return roundTo(res, 2)
}

const roundTo = (num: number, decimalPoints: number) => {
  return +(Math.round(Number(num + `e+${decimalPoints}`)) + `e-${decimalPoints}`);
};

